var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, IconIllustrativeLogin, Modal, TextHeadline2, TextCallout2, SchibstedLogo, VendLogo } from '@blocket/blocket-ui';
import { actionCreators as blhActionCreators } from '../../reduxBits/blocketLoginHelper';

var mapStateToProps = function mapStateToProps(state) {
  return {
    loginAlertModel: state.blocketLoginHelper.loginAlert
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    blhActions: bindActionCreators(blhActionCreators, dispatch)
  };
};

var StyledModal = styled(Modal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 320px;\n  text-align: center;\n  padding: 24px 0;\n  @media screen and (max-width: 767px) {\n    border-radius: 10px;\n    width: 90%;\n    max-width: 100%;\n    left: 50%;\n    top: 50%;\n    height: auto;\n    transform: translate(-50%, -50%);\n  }\n"])));
var StyledTextHeadline2 = styled(TextHeadline2)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 16px;\n"])));
var StyledTextCallout2 = styled(TextCallout2)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0 16px 16px 16px;\n"])));
var ButtonWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  button {\n    width: 125px;\n  }\n"])));
var SchibstedInfo = styled(TextCallout2)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 36px 0px 6px;\n  padding: 0px 10px;\n"])));

var LoginAlert = function LoginAlert(_ref) {
  var blhActions = _ref.blhActions,
      loginAlertModel = _ref.loginAlertModel,
      _ref$vendBranding = _ref.vendBranding,
      vendBranding = _ref$vendBranding === void 0 ? false : _ref$vendBranding;

  if (!loginAlertModel.isOpen) {
    return null;
  }

  var onClose = function onClose() {
    blhActions.setLoginToContinue({
      isOpen: false,
      redirectUri: '',
      cancelUri: '',
      message: '',
      tag: ''
    });
  };

  return /*#__PURE__*/React.createElement(StyledModal, {
    label: "login-alert",
    open: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(IconIllustrativeLogin, null), /*#__PURE__*/React.createElement(StyledTextHeadline2, null, "F\xF6r att forts\xE4tta m\xE5ste du logga in"), loginAlertModel.message && /*#__PURE__*/React.createElement(StyledTextCallout2, null, loginAlertModel.message), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    type: "secondary"
  }, "Avbryt"), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: function onClick() {
      blhActions.goToLogin(loginAlertModel.redirectUri, loginAlertModel.cancelUri, loginAlertModel.tag);
    }
  }, "Logga in")), /*#__PURE__*/React.createElement(SchibstedInfo, null, "Blocket \xE4r en del av"), vendBranding ? /*#__PURE__*/React.createElement(VendLogo, null) : /*#__PURE__*/React.createElement(SchibstedLogo, {
    width: 80,
    height: 17
  }));
};

LoginAlert.propTypes = {
  blhActions: PropTypes.shape({
    goToLogin: PropTypes.func,
    setLoginToContinue: PropTypes.func
  }),
  loginAlertModel: PropTypes.shape({
    redirectUri: PropTypes.string,
    cancelUri: PropTypes.string,
    message: PropTypes.string,
    isOpen: PropTypes.bool,
    tag: PropTypes.string
  }),
  vendBranding: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginAlert);
//# sourceMappingURL=LoginAlert.js.map